(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabLinks = document.querySelectorAll('.tabs-section-header__link');
    const tabItems = document.querySelectorAll('.tabs-section-header__item');
    const tabContents = document.querySelectorAll('.tabs-section-content');

    tabLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();

        const targetId = this.getAttribute('href').substring(1);

        tabItems.forEach(item => {
          item.classList.remove('tabs-section-header__item--active');
          const tabLink = item.querySelector('[role="tab"]');
          if (tabLink)
            tabLink.setAttribute('aria-selected', 'false');



        });

        tabContents.forEach(content => {
          content.classList.remove('tabs-section-content--active');
          content.setAttribute('hidden', 'true');
        });

        this.parentElement.classList.add('tabs-section-header__item--active');
        this.setAttribute('aria-selected', 'true');

        const targetContent = document.getElementById(targetId);
        if (targetContent) {
          targetContent.classList.add('tabs-section-content--active');
          targetContent.removeAttribute('hidden');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
